var _defs, _rect, _rect2, _circle, _g, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndusFooterLuminousBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 860",
    role: "presentation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "topline",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#20C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FF2775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aura"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#087CFF",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 38,
    height: 38,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 0H0V38",
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.035,
    strokeWidth: 0.8
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4,
    fill: "url(#topline)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 860,
    fill: "url(#grid)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1260,
    cy: 140,
    r: 440,
    fill: "url(#aura)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.09,
    transform: "translate(1260 150)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 410,
    ry: 310
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 332,
    ry: 252
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 255,
    ry: 194,
    strokeDasharray: "3 8"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1328,
    cy: 64,
    r: 3,
    fill: "#FF2775"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndusFooterLuminousBackground);
export default __webpack_public_path__ + "static/media/andus-footer-luminous-background.30bf711a6d2c5a70c5c3c93b9ce57570.svg";
export { ForwardRef as ReactComponent };